export default class TestAPI {
  api = {
    getTests: "test/GetTests",
    createApplication: "test/CreateTest",
    updateTestLocally: "test/UpdateTest",
    deleteTest: "test/DeleteTest",
    getApplicationBackup: "test/GetApplicationBackup",
    upsertLeanParameters: "test/UpsertLeanParameters",
  };

  constructor(httpsClient) {
    this.httpsClient = httpsClient;
  }

  async getTests(data, token) {
    return await this.get(this.api.getTests, data, token);
  }


  async updateTest(data, token) {
    return await this.post(this.api.updateTestLocally, data, token);
  }

  async deleteTest(data, token) {
    return await this.get(this.api.deleteTest, data, token);
  }

  async upsertLeanParameters(data, token) {
    return this.post(this.api.upsertLeanParameters, data, token);
  }

  async createApplication(data, token) {
    return this.post(this.api.createApplication, data, token);
  }

  async get(url, data, token) {
    const response = await this.httpsClient.get(url, data, token);
    return response;
  }

  async post(url, data, token) {
    await this.httpsClient.post(url, data, token);
  }
}
